import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M16.75 23H6.75C5.64543 23 4.75 22.1046 4.75 21V3C4.75 1.89543 5.64543 1 6.75 1H16.75C17.8546 1 18.75 1.89543 18.75 3V21C18.75 22.1046 17.8546 23 16.75 23ZM6.75 3V21H16.75V3H6.75ZM11.75 20C11.1977 20 10.75 19.5523 10.75 19C10.75 18.4477 11.1977 18 11.75 18C12.3023 18 12.75 18.4477 12.75 19C12.75 19.5523 12.3023 20 11.75 20Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "MobileAlt"
);
